import { useQuery, UseQueryOptions } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";
import { IntlBookingSummary } from "../@types/intlFlightAggregator";

/**
 * Lists the current user's international (Duffel) bookings — kept separate
 * from useFlightBookings (Travex-only) since it's a different backend model
 * with a different shape; see InternationalFlightAggregatorController::bookings.
 */
function useInternationalFlightBookings(
  options?: Omit<UseQueryOptions<APIResponse<{ bookings: IntlBookingSummary[] }>, APIError>, "queryKey" | "queryFn">
) {
  const query = useQuery<APIResponse<{ bookings: IntlBookingSummary[] }>, APIError>({
    queryKey: ["international-flight-bookings"],
    queryFn: () =>
      get(`${API_URL}/aviation/international/v2/bookings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }),
    ...options,
  });

  return {
    internationalBookings: query.data?.data?.bookings ?? [],
    fetchingInternationalBookings: query.isLoading,
    isRefetchingInternationalBookings: query.isFetching && !query.isLoading,
    refreshInternationalBookings: query.refetch,
  };
}

export default useInternationalFlightBookings;
